<template>
  <div>
    <b-card>
      <h5 class="pb-2">Dodaj dni wolne</h5>
      <b-form>
        <b-form-group label="Nazwa">
          <b-input v-model="name"></b-input>
        </b-form-group>
        <b-row>
          <b-col cols="6">
            <b-form-group label="Okres">
              <b-select v-model="type" :options="types"></b-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <color-picker @picked="colorPicked"></color-picker>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group label="Data rozpoczęcia">
              <date-picker :monday-first="true" :language="dpLanguage" v-model="dateStart" format="dd.MM.yyyy" inputClass="form-control"></date-picker>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Data zakończenia">
              <date-picker :monday-first="true" :language="dpLanguage" :disabled="type === 0" v-model="dateEnd" format="dd.MM.yyyy" inputClass="form-control"></date-picker>
            </b-form-group>
          </b-col>
        </b-row>
        <b-btn type="submit" class="float-right" @click="save" variant="outline-primary">Zapisz</b-btn>
      </b-form>
    </b-card>
    <b-card class="mt-4">
      <h5>Dni Wolne</h5>
      <b-list-group>
        <b-list-group-item v-b-toggle="holidayGroup[0].group ? holidayGroup[0].name : 'Jednorazowe'" v-for="holidayGroup in holidays" :key="holidayGroup.index">
          <h6 class="d-inline-block">{{ holidayGroup[0].group ? holidayGroup[0].name : 'Jednorazowe' }}</h6>
          <b-btn
            v-if="holidayGroup[0].group"
            variant="outline-danger"
            class="float-right"
            size="sm"
            @click="
              confirmModal = true;
              confirmData.groupNumber = holidayGroup[0].group;
              confirmData.name = holidayGroup[0].name;
            "
            >Usuń grupę</b-btn
          >
          <b-collapse :id="holidayGroup[0].group ? holidayGroup[0].name : 'Jednorazowe'">
            <b-list-group class="mt-3">
              <b-list-group-item class="hover" v-for="holidayItem in holidayGroup" :key="holidayItem.id">
                {{ holidayItem.name }}: {{ holidayItem.date.format('DD.MM.YYYY') }}
                <b-btn
                  @click="
                    confirmModal = true;
                    confirmData.id = holidayItem.id;
                    confirmData.name = holidayItem.name;
                  "
                  variant="outline-danger"
                  class="float-right"
                  size="sm"
                  >Usuń</b-btn
                >
              </b-list-group-item>
            </b-list-group>
          </b-collapse>
        </b-list-group-item>
      </b-list-group>
    </b-card>
    <confirm-modal v-if="confirmModal" :confirmModal="confirmModal" @cancel="onModalHide" @ok="removeHoliday">
      <span slot="body">Czy na pewno chcesz usunąć {{ confirmData.id ? `ten dzień wolny (${confirmData.name})` : `tą grupę (${confirmData.name})` }} ?</span>
    </confirm-modal>
  </div>
</template>
<script>
import DatePicker from 'vuejs-datepicker';
import { pl } from 'vuejs-datepicker/dist/locale';
import ColorPicker from '@/components/ColorPicker.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';

import moment from 'moment';
import { HolidayResource } from '@/resources/holiday.resource';

export default {
  components: { DatePicker, ColorPicker, ConfirmModal },
  data() {
    return {
      dpLanguage: pl,
      name: '',
      dateStart: '',
      dateEnd: '',
      color: '#ffffff',
      type: 0,
      types: [
        { value: 0, text: 'Jednorazowo' },
        { value: 2, text: 'Poniedziałki' },
        { value: 3, text: 'Wtorki' },
        { value: 4, text: 'Środy' },
        { value: 5, text: 'Czwartki' },
        { value: 6, text: 'Piątki' },
        { value: 7, text: 'Soboty' },
        { value: 1, text: 'Niedziele' },
        { value: 8, text: 'Co tydzień' },
        { value: 9, text: 'Co miesiąc' },
        { value: 10, text: 'Co rok' }
      ],
      rawHolidays: [],
      holidays: [],
      confirmModal: false,
      confirmData: {
        name: '',
        id: null,
        groupNumber: null
      }
    };
  },
  methods: {
    colorPicked(color) {
      this.color = color;
    },
    async save() {
      if (!this.name || (this.type !== 0 && !this.dateEnd) || !this.dateStart || !this.$isAdmin()) {
        this.$notify({ type: 'error', title: 'Błąd', text: 'Proszę wypełnić formularz' });
        return;
      }
      try {
        await HolidayResource.add(this.name, this.color, this.type, this.dateStart, this.dateEnd);
        this.$notify({ type: 'success', title: 'Dni wolne', text: 'Pomyślnie dodano dni wolne do kalendarza' });
      } catch (error) {
        this.$notify({ type: 'error', title: 'Błąd', text: error.message });
      }
    },
    async getHolidays() {
      try {
        this.rawHolidays = await HolidayResource.list();
        this.groupHolidays(this.rawHolidays);
      } catch (error) {
        console.warn(error);
      }
    },
    groupHolidays(array) {
      const holidaysGrouped = array
        .filter(holiday => !!holiday.id)
        .reduce((groups, holiday) => {
          groups[holiday.group || 0] = [holiday].concat(groups[holiday.group || 0] || []);
          return groups;
        }, {});
      this.$set(this, 'holidays', Object.values(holidaysGrouped));
    },
    async deleteHoliday(id) {
      id = parseInt(id, 10);
      try {
        await HolidayResource.delete(id);
        this.$notify({ type: 'success', text: 'Pomyślnie usunięto dzień wolny', title: 'Sukces' });
        this.rawHolidays.splice(this.rawHolidays.findIndex(holiday => holiday.id === id), 1);
        this.groupHolidays(this.rawHolidays);
      } catch (error) {
        console.warn(error);
      }
    },
    async deleteHolidayGroup(groupNumber) {
      try {
        await HolidayResource.deleteGroup(groupNumber);
        this.holidays.splice(this.holidays.findIndex(group => group[0].group === groupNumber), 1);
      } catch (error) {
        console.warn(error);
      }
    },
    onModalHide() {
      this.confirmModal = false;
      this.confirmData = {
        name: '',
        id: null,
        groupNumber: null
      };
    },
    removeHoliday() {
      if (this.confirmData.id) {
        this.deleteHoliday(this.confirmData.id);
      } else if (this.confirmData.groupNumber) {
        this.deleteHolidayGroup(this.confirmData.groupNumber);
      }
      this.onModalHide();
    }
  },
  mounted() {
    this.getHolidays();
  }
};
</script>
<style>
select {
  position: static !important;
  z-index: 0;
}
.hover:hover {
  background-color: #f3f3f3;
}
</style>
